import ApiURLs from "@/ApiURLs";
import HttpService from "../HttpService";
import { MethodType } from "@/models/http/MethodType";
import { MessageSendingResult } from "@/models/messages/messageSendingResult";
import SaveSurveyDto from "@/models/survey/saveSurveyDto";

export class SurveyService {
   public static async saveSurvey(saveSurveyDto: SaveSurveyDto) {
      const url = ApiURLs.saveSurvey;

      const response = await HttpService.send<MessageSendingResult>(url, MethodType.POST, saveSurveyDto);

      return response.data;
   }
}